import { render } from "./ProductImportHistory.vue?vue&type=template&id=33c04f37"
import script from "./ProductImportHistory.vue?vue&type=script&lang=js"
export * from "./ProductImportHistory.vue?vue&type=script&lang=js"

import "./ProductImportHistory.vue?vue&type=style&index=0&id=33c04f37&lang=scss"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__